"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const QuestionIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 100 100" }),
    react_1.default.createElement("path", { d: "M50,97.79A47.79,47.79,0,1,0,2.21,50,47.85,47.85,0,0,0,50,97.79Zm0-86.25A38.45,38.45,0,1,1,11.55,50,38.49,38.49,0,0,1,50,11.55Zm4.35,61.88a4.94,4.94,0,1,1-4.94-4.94A4.94,4.94,0,0,1,54.35,73.43ZM34,34.92a4.89,4.89,0,0,1,.21-3.75,16.72,16.72,0,0,1,15-9.53h.1A17,17,0,0,1,66.23,38,16.75,16.75,0,0,1,54.82,54.4s-.49.17-.49.46v3.92a4.91,4.91,0,0,1-9.83,0V54.86a10.39,10.39,0,0,1,7.16-9.77,7,7,0,0,0,4.75-6.85,7.17,7.17,0,0,0-7.06-6.79,7,7,0,0,0-6.25,4A4.91,4.91,0,0,1,34,34.92Z" })));
exports.QuestionIcon = QuestionIcon;
exports.default = exports.QuestionIcon;
